import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import profile from "../../images/profile_welcome.png";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PauseIcon from "@mui/icons-material/Pause";
import { FiRotateCcw } from "react-icons/fi";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import "../Employee/emstyle.css";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import BadgeIcon from "@mui/icons-material/Badge";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { MdPeopleOutline } from "react-icons/md";
import {
  Alert,
  ButtonGroup,
  IconButton,
  Snackbar,
  Tooltip,
} from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import TableRowsIcon from "@mui/icons-material/TableRows";
import { Link } from "react-router-dom";
import { MdAssignmentAdd } from "react-icons/md";
import { FaRegFilePdf } from "react-icons/fa6";
import { FaPrint } from "react-icons/fa6";
import { GrView } from "react-icons/gr";
import { FaRegEdit } from "react-icons/fa";
import { usePDF } from "react-to-pdf";
import { FallingLines } from "react-loader-spinner";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ViewModuleSharpIcon from "@mui/icons-material/ViewModuleSharp";
import TableViewSharpIcon from "@mui/icons-material/TableViewSharp";
import VerifiedUserSharpIcon from "@mui/icons-material/VerifiedUserSharp";
import HourglassBottomSharpIcon from "@mui/icons-material/HourglassBottomSharp";
import Chip from "@mui/material/Chip";
import BadgeSharpIcon from "@mui/icons-material/BadgeSharp";
import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import { FaSearch } from "react-icons/fa";
import user1 from "../../images/ic_no_person_photo.svg";
import { getReadableDateDDMMYYYY } from "../../utils/utils";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";

const Employee = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;
  const [base_url] = useState(base_url_from_axios_config);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toPDF, targetRef } = usePDF({ filename: "Emplist.pdf" });

  const [data, setData] = useState(null);
  const [searchdata, setSearchData] = useState("");
  const [loader, setLoader] = useState(true);
  const [Division, setDivision] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [grade, setGrade] = useState(null);
  const [selectedgrade, setSelectedGrade] = useState("");
  const [jobtitle, setJobTitle] = useState(null);
  const [selectedJob, setSelectedJobTitle] = useState("");
  const [jobMUI, setJobMUI] = useState("");
  const [gradeMUI, setGradeMUI] = useState("");
  const [divisionMUI, setDivisionMUI] = useState("");
  const [resetalldata, setResetallData] = useState(false);
  const [Open, setOpen] = useState(false);
  const [dataView, setDataView] = useState("grid");
  const [currentPage, setCurrentPage] = useState(1);
  const [isActive, setIsActive] = useState("YES");

  const recordsPerPage = 20;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = (messageText, severityText) => {
    setSnackbar({
      open: true,
      message: messageText,
      severity: severityText,
    });
  };

  const closeSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  console.log("Records:", records);
  // Handle popover for important dates
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    return false;
  };
  const handleClose = () => setAnchorEl(null);
  const openImportantDatesPopover = Boolean(anchorEl);
  const idImportantDatesPopover = openImportantDatesPopover
    ? "simple-popover"
    : undefined;

  // Fetch profile picture
  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user1;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  // Handle dropdown changes and update URL
  const handleChange = (event, eventType) => {
    const value = event.target.value;
    switch (eventType) {
      case "jobTitle":
        setSelectedJobTitle(value);
        setJobMUI(value);
        break;
      case "grade":
        setSelectedGrade(value);
        setGradeMUI(value);
        break;
      case "division":
        setSelectedDivision(value);
        setDivisionMUI(value);
        break;
      default:
        break;
    }
    // Update URL with new filter values
    const newParams = new URLSearchParams({
      jobTitle: eventType === "jobTitle" ? value : selectedJob,
      grade: eventType === "grade" ? value : selectedgrade,
      division: eventType === "division" ? value : selectedDivision,
    }).toString();
    setSearchParams(newParams);
  };

  // const getData = async (empStatus) => {
  const getData = async () => {
    setLoader(true);
    try {
      // Read query parameters
      const jobTitleFromQuery = searchParams.get("jobTitle") || "";
      const gradeFromQuery = searchParams.get("grade") || "";
      const divisionFromQuery = searchParams.get("division") || "";

      // Validate query parameters against master data
      const isValidJobTitle =
        jobTitleFromQuery &&
        jobtitle?.some((job) => job.Description === jobTitleFromQuery);
      const isValidGrade =
        gradeFromQuery && grade?.some((g) => g.Description === gradeFromQuery);
      const isValidDivision =
        divisionFromQuery &&
        Division?.some((div) => div.Description === divisionFromQuery);

      // Update filter states if query parameters are valid and not already set
      if (isValidJobTitle && jobTitleFromQuery !== selectedJob) {
        setSelectedJobTitle(jobTitleFromQuery);
        setJobMUI(jobTitleFromQuery);
      }
      if (isValidGrade && gradeFromQuery !== selectedgrade) {
        setSelectedGrade(gradeFromQuery);
        setGradeMUI(gradeFromQuery);
      }
      if (isValidDivision && divisionFromQuery !== selectedDivision) {
        setSelectedDivision(divisionFromQuery);
        setDivisionMUI(divisionFromQuery);
      }

      // Determine API parameters
      // const jobTitleParam = resetalldata
      //   ? "ALL"
      //   : isValidJobTitle
      //     ? jobTitleFromQuery
      //     : selectedJob || "ALL";
      // const gradeParam = resetalldata
      //   ? "ALL"
      //   : isValidGrade
      //     ? gradeFromQuery
      //     : selectedgrade || "ALL";
      // const divisionParam = resetalldata
      //   ? "ALL"
      //   : isValidDivision
      //     ? divisionFromQuery
      //     : selectedDivision || "ALL";
      // const searchParam = resetalldata ? "ALL" : searchdata || "ALL";
      // const searchType = searchdata && !resetalldata ? "FREETEXT" : "ALL";
      const getParam = (reset, queryValid, queryValue, selectedValue) => {
        if (reset) return "ALL";
        if (queryValid) return queryValue;
        return selectedValue || "ALL";
      };

      const jobTitleParam = getParam(
        resetalldata,
        isValidJobTitle,
        jobTitleFromQuery,
        selectedJob,
      );

      const gradeParam = getParam(
        resetalldata,
        isValidGrade,
        gradeFromQuery,
        selectedgrade,
      );

      const divisionParam = getParam(
        resetalldata,
        isValidDivision,
        divisionFromQuery,
        selectedDivision,
      );

      const searchParam = resetalldata ? "ALL" : searchdata || "ALL";
      const searchType = searchdata && !resetalldata ? "FREETEXT" : "ALL";

      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/${isActive}/${searchParam}/${jobTitleParam}/${gradeParam}/${divisionParam}`,
      );

      if (response?.data) {
        setData(response.data);
        setCurrentPage(1); // Reset pagination
        if (
          (jobTitleFromQuery || gradeFromQuery || divisionFromQuery) &&
          !resetalldata
        ) {
          // toast.info("Filters applied from previous page");
          showSnackbar("Filters applied from previous page", "info");
        }
      } else {
        showSnackbar("No employee data found", "error");
        // toast.error("No employee data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showSnackbar("Error fetching employee data", "error");
      // toast.error("Error fetching employee data");
    } finally {
      setLoader(false);
      if (resetalldata) setResetallData(false);
    }
  };
  // Consolidated data fetching
  useEffect(() => {
    if (base_url && companyCode && jobtitle && grade && Division) {
      // getData("YES");
      getData();
    }
  }, [
    base_url,
    companyCode,
    searchParams,
    searchdata,
    selectedJob,
    selectedgrade,
    selectedDivision,
    resetalldata,
    jobtitle,
    grade,
    Division,
    isActive,
  ]);

  // useEffect(()=>{
  //   getData()
  // },[resetalldata])

  // Master data fetching
  useEffect(() => {
    const getDivisionData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
        );
        if (response?.data) setDivision(response.data);
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };
    if (base_url && companyCode) getDivisionData();
  }, [base_url, companyCode]);

  useEffect(() => {
    const getJobTitleData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/MasterList/${companyCode}/JOBTITLE/-`,
        );
        if (response?.data) setJobTitle(response.data);
      } catch (error) {
        console.error("Error fetching job titles:", error);
      }
    };
    if (base_url && companyCode) getJobTitleData();
  }, [base_url, companyCode]);

  useEffect(() => {
    const getGradeData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
        );
        if (response?.data) setGrade(response.data);
      } catch (error) {
        console.error("Error fetching grades:", error);
      }
    };
    if (base_url && companyCode) getGradeData();
  }, [base_url, companyCode]);

  // Update URL when resetting filters
  const handleReset = () => {
    setResetallData(true);
    setSearchData("");
    setSelectedJobTitle("");
    setSelectedGrade("");
    setSelectedDivision("");
    setJobMUI("");
    setGradeMUI("");
    setDivisionMUI("");
    setSearchParams(""); // Clear query parameters
  };

  // Navigation to EditForm with current filters
  const navigateToEdit = (empId) => {
    const queryParams = new URLSearchParams({
      jobTitle: selectedJob || "",
      grade: selectedgrade || "",
      division: selectedDivision || "",
    }).toString();
    navigate(`/admin/emp_edit/${encodeURIComponent(empId)}?${queryParams}`);
  };

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment) setDataView(newAlignment);
  };

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const formatDateWithExpiry = (date) => {
    if (!date) return <span>-</span>;

    const parsed = new Date(date);
    if (isNaN(parsed)) return <span>-</span>;

    const isExpired = parsed < new Date();

    return (
      <span className={isExpired ? "text-red-600 font-medium" : ""}>
        {parsed.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    );
  };

  const printEmpList = () => {
    navigate("/admin/employeeListReport", { state: { emplistData: records } });
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="w-full lg:w-2/3">
            <div className="flex justify-left items-center">
              <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>

              <h6 className="text-xl font-bold text-gray-900 flex items-center gap-2 ">
                {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
                  <MdPersonAddAlt className="w-7 h-7" />
                  </span> */}
                {/* <EditIcon className="text-[#2663EB]" />  */}
                <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                  EMPLOYEE LIST
                </span>
              </h6>
            </div>
          </div>
          <div className="flex justify-end items-center gap-2 my-3">
            <button
              onClick={printEmpList}
              className="bg-teal-600 hover:bg-teal-700 text-white font-semibold flex items-center gap-2 px-2 py-1 rounded-md shadow-md transition duration-200"
            >
              <FaPrint className="text-white" />
              Print
            </button>
            <button
              onClick={() => toPDF()}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold flex items-center gap-2 px-2 py-1 rounded-md shadow-md transition duration-200"
            >
              <FaRegFilePdf className="text-white" />
              Export
            </button>
            <button
              onClick={() => navigate("emp_reg")}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold flex items-center gap-2 px-2 py-1 rounded-md shadow-md transition duration-200"
            >
              <MdAssignmentAdd className="text-lg" />
              Registration
            </button>
          </div>
        </div>
        <div className="flex  items-center justify-between my-2 ">
          <div>
            <div className="flex w-fit bg-[#F3F4F6] p-1 rounded-full shadow-md">
              <button
                type="button"
                onClick={() => {
                  setIsActive("YES");
                  // getData("YES");
                  // getData();
                }}
                className={`px-6 py-2 text-sm rounded-full transition-all duration-300 font-medium
      ${
        isActive === "YES"
          ? "bg-[#2663EB] text-white shadow-md font-semibold"
          : "text-gray-600 font-semibold"
      }`}
                style={{
                  fontFamily:
                    "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                }}
              >
                Active
              </button>

              <button
                type="button"
                onClick={() => {
                  setIsActive("NO");
                  // getData("NO");
                  // getData();
                }}
                className={`px-6 py-2 text-sm rounded-full transition-all duration-300 font-medium
      ${
        isActive === "NO"
          ? "bg-[#2663EB] text-white shadow-md"
          : "text-[gray-600]"
      }`}
                style={{
                  fontFamily:
                    "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                }}
              >
                Inactive
              </button>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-end gap-4 flex-wrap">
            <div className="w-full sm:w-1/2 md:w-1/4">
              {/* <div className="flex items-center border-b border-gray-400 py-2 px-3">
                  <FaSearch className="text-blue-500 text-sm mr-2" />
                  <input
                    type="text"
                    placeholder="Search"
                    className="border-none outline-none bg-transparent flex-1 text-sm w-full"
                    value={searchdata}
                    onChange={(e) => setSearchData(e.target.value)}
                  />
                </div> */}

              <div className="w-[200px] flex items-center gap-2 p-2  border border-gray-700 rounded-md transition-all duration-200  focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
                <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

                <input
                  type="text"
                  placeholder="Search By ID or Name..."
                  value={searchdata}
                  onChange={(e) => setSearchData(e.target.value)}
                  className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
                />

                {searchdata && (
                  <button
                    onClick={() => setSearchData("")}
                    className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>
            <div className="w-full sm:w-1/2 md:w-1/4 flex items-center justify-between gap-4">
              <FormControl
                variant="outlined"
                sx={{
                  minWidth: { xs: "100%", sm: 160 },
                  maxWidth: { xs: "100%", sm: 180 },
                }}
                size="small"
              >
                <InputLabel id="job-title-label">Job Title</InputLabel>
                <Select
                  labelId="job-title-label"
                  value={jobMUI}
                  onChange={(e) => handleChange(e, "jobTitle")}
                  label="Job Title"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {jobtitle?.map((job) => (
                    <MenuItem key={job.Description} value={job.Description}>
                      {job.Description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                sx={{
                  minWidth: { xs: "100%", sm: 160 },
                  maxWidth: { xs: "100%", sm: 180 },
                }}
                size="small"
              >
                <InputLabel id="grade-label">Grade</InputLabel>
                <Select
                  labelId="grade-label"
                  value={gradeMUI}
                  onChange={(e) => handleChange(e, "grade")}
                  label="Grade"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {grade?.map((g) => (
                    <MenuItem key={g.Description} value={g.Description}>
                      {g.Description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                sx={{
                  minWidth: { xs: "100%", sm: 160 },
                  maxWidth: { xs: "100%", sm: 180 },
                }}
                size="small"
              >
                <InputLabel id="division-label">Division</InputLabel>
                <Select
                  labelId="division-label"
                  value={divisionMUI}
                  onChange={(e) => handleChange(e, "division")}
                  label="Division"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {Division?.map((div) => (
                    <MenuItem key={div.Description} value={div.Description}>
                      {div.Description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <button
                onClick={handleReset}
                className="bg-gray-500 hover:bg-gray-700 text-white font-semibold flex items-center gap-2 px-2 py-1 rounded-md shadow-md transition duration-200"
              >
                <FiRotateCcw className="text-lg" />
                Reset
              </button>
            </div>
          </div>

          <ButtonGroup variant="outlined" size="small" aria-label="view toggle">
            <Tooltip title="Grid View">
              <IconButton
                color={dataView === "grid" ? "primary" : "default"}
                onClick={() => handleAlignment(null, "grid")}
              >
                <GridViewIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Table View">
              <IconButton
                color={dataView === "table" ? "primary" : "default"}
                onClick={() => handleAlignment(null, "table")}
              >
                <TableRowsIcon />
              </IconButton>
            </Tooltip>
          </ButtonGroup>
        </div>
        {dataView === "table" && (
          <div
            className={
              Open
                ? "table scroll list-table mt-2 h-auto"
                : "table scroll list-table mt-2 h-auto"
            }
            style={{ maxHeight: "550px" }}
            ref={targetRef}
          >
            <div className="flex justify-end items-end">
              {Open ? (
                <LuPanelRightOpen
                  onClick={() => setOpen(false)}
                  className="text-xl cursor-pointer mr-2 mb-2"
                />
              ) : (
                <LuPanelLeftOpen
                  onClick={() => setOpen(true)}
                  className="text-xl cursor-pointer mr-2 mb-2"
                />
              )}
            </div>

            <div className="overflow-auto max-w-[84vw] max-h-[60vh] rounded-xl border scrollbar-none ">
              <table className="min-w-full border-separate border-spacing-0">
                <thead className="sticky top-0 z-10">
                  <tr className="bg-[#2663EB] text-white text-sm">
                    <th className="px-3 py-2 font-medium text-left">Sl</th>
                    <th className="px-3 py-2 font-medium text-left">Emp ID</th>
                    <th className="px-3 py-2 font-medium text-left">Alt ID</th>
                    <th className="px-3 py-2 font-medium text-left">Status</th>
                    <th className="px-3 py-2 font-medium text-left">Name</th>
                    <th className="px-3 py-2 font-medium text-left">
                      Job Title
                    </th>
                    <th className="px-3 py-2 font-medium text-left">
                      Division
                    </th>
                    <th className="px-3 py-2 font-medium text-left">Grade</th>
                    <th className="px-3 py-2 font-medium text-left">Gender</th>
                    <th className="px-3 py-2 font-medium text-left">
                      Nationality
                    </th>

                    {Open && (
                      <>
                        {[
                          "Bank Account",
                          "Bank Name",
                          "Agent Id",
                          "Current Address",
                          "Home Address",
                          "Home Airport",
                          "Work Mobile",
                          "Work Phone",
                          "Personal Phone",
                          "Personal Email",
                          "Passport Number",
                          "Passport Issue Date",
                          "Passport Expiry Date",
                          "Passport Place of Issue",
                          "Passport Country of Issue",
                          "Emirates Id",
                          "Expiry Date",
                          "Visa No",
                          "Visa Expiry Date",
                          "Insurance Number",
                          "Insurance Expiry Date",
                          "Driving License No",
                          "Driving License Expiry Date",
                          "Basic Pay",
                          "Allowances OT",
                          "Allowances NOT",
                          "Normal HRS",
                          "Hourly Wage",
                          "OT Rate",
                          "Spl OT Rate",
                          "Active",
                          "Memos",
                          "Notes",
                          "Salary Ac",
                          "Advance Ac",
                        ].map((col, i) => (
                          <th
                            key={i}
                            className="px-3 py-2 font-medium text-left whitespace-nowrap"
                          >
                            {col}
                          </th>
                        ))}
                      </>
                    )}

                    <th className="px-3 py-2 font-medium text-left">Actions</th>
                  </tr>
                </thead>

                <tbody className="text-sm text-gray-700">
                  {records?.map((d, i) => (
                    <tr
                      key={i}
                      className="border hover:bg-gray-50 transition-colors duration-150"
                    >
                      <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                        {/* {i + 1} */}
                        {firstIndex + i + 1}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border ">
                        {d?.EmpId}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.AlternateID}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Status}
                      </td>

                      {/* Name + Avatar */}
                      <td className="px-3 py-2 whitespace-nowrap border">
                        <div className="flex items-center gap-2">
                          <img
                            className="w-7 h-7 rounded-full object-cover"
                            src={
                              d.imagepath ? fetchProfilePic(d.imagepath) : user1
                            }
                            alt=""
                          />
                          <span>{d?.Name}</span>
                        </div>
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.JobTitle}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Division}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Grade}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Single}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Nationality}
                      </td>

                      {Open && (
                        <>
                          {[
                            d?.BankAccountNo,
                            d?.BankName,
                            d?.AgentID,
                            d?.CurrentAddress,
                            d?.HomeAddress,
                            d?.HomeAirport,
                            d?.WorkMobile,
                            d?.WorkPhone,
                            d?.PersonalPhone,
                            d?.PersonalEmail,
                            d?.PassportNo,
                            formatDateWithExpiry(d?.PassportIssueDate),
                            formatDateWithExpiry(d?.PassportExpiryDate),
                            d?.PassportPlaceofIssue,
                            d?.PassportCountryofIssue,
                            d?.EmiratesId,
                            formatDateWithExpiry(d?.EmiratesIdExpiryDate),
                            d?.VisaNo,
                            formatDateWithExpiry(d?.VisaExpiryDate),
                            d?.InsuranceNo,
                            formatDateWithExpiry(d?.InsuranceExpiryDate),
                            d?.DrivingLicenceNo,
                            formatDateWithExpiry(d?.DrivingLicenceExpiryDate),
                            d?.BasicPay,
                            d?.Allowances_OT,
                            d?.Allowances_NOT,
                            d?.NormalHrs,
                            d?.HourlyWage,
                            d?.OTrate,
                            d?.SplOtRate,
                            d?.Active,
                            d?.Memos,
                            d?.Notes,
                            d?.SalaryA,
                            d?.AdvanceAc,
                          ].map((val, index) => (
                            <td
                              key={index}
                              className="px-3 py-2 whitespace-nowrap border text-gray-600"
                            >
                              {val || "-"}
                            </td>
                          ))}
                        </>
                      )}

                      {/* Actions */}
                      <td className="px-3 py-2 whitespace-nowrap border">
                        <div className="flex items-center justify-center gap-3 text-lg">
                          {/* <Link
            to={`view_emp/${encodeURIComponent(d?.EmpId)}`}
            className="text-gray-500 hover:text-[#2663EB] transition"
          >
            <GrView />
          </Link> */}

                          <Link
                            onClick={() => navigateToEdit(d?.EmpId)}
                            to={`emp_edit/${encodeURIComponent(
                              d?.EmpId,
                            )}?jobTitle=${encodeURIComponent(
                              selectedJob || "",
                            )}&grade=${encodeURIComponent(
                              selectedgrade || "",
                            )}&division=${encodeURIComponent(
                              selectedDivision || "",
                            )}`}
                            className="text-gray-500 hover:text-[#2663EB] transition"
                          >
                            <FaRegEdit />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {dataView === "grid" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 p-[4px] my-4">
            {records?.map((item, index) => (
              <Link
                to={`emp_edit/${encodeURIComponent(item?.EmpId)}?jobTitle=${encodeURIComponent(selectedJob || "")}&grade=${encodeURIComponent(selectedgrade || "")}&division=${encodeURIComponent(selectedDivision || "")}`}
                onClick={() => navigateToEdit(item?.EmpId)}
                className="w-full h-auto p-2 flex flex-col items-center rounded-lg border border-white shadow-sm bg-white hover:shadow-md transition-shadow duration-200"
                key={index}
              >
                <div className="flex flex-col items-center w-full">
                  <div style={{ position: "relative" }}>
                    {/* {item.Status.toLowerCase() === "active" ||
                    item.Status.toLowerCase() === "confirmed employee" ? ( */}
                    {item.Active.toLowerCase() === "yes" ? (
                      <div
                        className="my-1 text-[6px] sm:text-[7px] text-gray-600"
                        style={{
                          position: "absolute",
                          top: "3px",
                          transform: "translateX(-95%)",
                          borderRadius: "50%",
                          padding: "2px",
                        }}
                      >
                        <Chip
                          size="small"
                          icon={
                            <FiberManualRecordIcon
                              style={{ color: "white" }}
                              className="w-2 h-2 sm:w-3 sm:h-3"
                            />
                          }
                          label="Active"
                          sx={{
                            backgroundColor: "#2663EB",
                            color: "white",
                            fontWeight: "bold",
                            "& .MuiChip-icon": { color: "white" },
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="my-1 text-[8px] sm:text-[7px] text-gray-600"
                        style={{
                          position: "absolute",
                          top: "3px",
                          transform: "translateX(-90%)",
                          borderRadius: "50%",
                          padding: "2px",
                        }}
                      >
                        <Chip
                          size="small"
                          icon={
                            <PauseIcon
                              style={{ color: "white" }}
                              className="w-2 h-2 sm:w-3 sm:h-3"
                            />
                          }
                          label="Inactive"
                          sx={{
                            backgroundColor: "#BDBDBD",
                            color: "white",
                            fontWeight: "bold",
                            "& .MuiChip-icon": { color: "white" },
                          }}
                        />
                      </div>
                    )}
                    <div className="p-2">
                      {item?.imagepath ? (
                        <img
                          className="w-[60px] h-[55px] sm:w-[80px] sm:h-[75px] object-cover rounded-full shadow-md"
                          src={fetchProfilePic(item.imagepath)}
                          alt=""
                        />
                      ) : (
                        <img
                          className="w-[60px] h-[55px] sm:w-[80px] sm:h-[75px] object-cover rounded-full"
                          src={user1}
                          alt=""
                        />
                      )}
                    </div>
                  </div>
                  <div className="mt-2 text-center">
                    <div className="my-1 text-[14px] sm:text-[16px] w-full font-semibold">
                      {item.Name}
                    </div>
                    <div className="mb-1 text-[12px] sm:text-[14px] text-gray-600">
                      {item.JobTitle}
                    </div>
                    <div className="my-2 p-1 sm:p-2 w-full sm:w-[260px] py-3 border border-gray-300 rounded bg-gray-100 flex flex-col justify-between items-center gap-1 sm:gap-2">
                      <div className="mb-1 text-[12px] sm:text-[14px] text-gray-600">
                        <SchemaOutlinedIcon
                          style={{ color: "#757575", fontSize: "12px" , marginRight:'2px' }}
                          className="inline-block"
                        />{" "}
                        :{" "}
                        {item.Division || (
                          <span className="inline-block h-2 w-16 bg-gray-300 rounded-sm animate-pulse mt-1 ml-2" />
                        )}
                      </div>
                      <div className=" text-[12px] sm:text-[14px] text-gray-600 mb-1">
                        <EmailOutlinedIcon
                          style={{ color: "#757575", fontSize: "12px" , marginRight:'2px' }}
                          className="inline-block"
                        />{" "}
                        :{" "}
                        {item.WorkEmail || (
                          <span className="inline-block h-2 w-16 bg-gray-300 rounded-sm animate-pulse mt-1 ml-2" />
                        )}
                      </div>
                      <div className="mb-1 text-[12px] sm:text-[14px] text-gray-600">
                        <PhoneOutlinedIcon
                          style={{ color: "#757575", fontSize: "12px" , marginRight:'2px' }}
                          className="inline-block"
                        />{" "}
                        :{" "}
                        {item.WorkMobile || (
                          <span className="inline-block h-2 w-16 bg-gray-300 rounded-sm animate-pulse mt-1 ml-2" />
                        )}
                      </div>
                      <div className="flex items-center justify-center mb-1 text-[12px] sm text-[14px] text-gray-600">
                        <WorkOutlineIcon
                          style={{ color: "#757575", fontSize: "12px" , marginRight:'2px' }}
                          className="inline-block"
                        />{" "}
                        :{" "}
                        {item.JobType || (
                          <span className="inline-block h-2 w-16 bg-gray-300 rounded-sm animate-pulse mt-1 ml-2" />
                        )}
                      </div>
                      <div className="my-1">
                        <Chip
                          size="small"
                          icon={
                            <BadgeIcon
                              style={{ color: "white" }}
                              className="w-2 h-2 sm:w-3 sm:h-3"
                            />
                          }
                          label={item.EmpId}
                          sx={{
                            backgroundColor: "#03a1fc",
                            color: "white",
                            "& .MuiChip-icon": { color: "white" },
                          }}
                        />
                      </div>
                      {item.Division ? (
                        <p className="ms-2">
                          <Chip
                            size="small"
                            icon={<ApartmentSharpIcon />}
                            sx={{ backgroundColor: "#FF6D74", color: "white" }}
                            label={item.Division}
                          />
                        </p>
                      ) : (
                        <span className="inline-block h-4 w-24 bg-red-200 rounded-full animate-pulse mt-1 ml-2" />
                      )}
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
                      <div>
                        <span
                          className="flex items-center justify-center"
                          style={{ color: "#7f7f7f", fontSize: "10px" }}
                        >
                          Joined {getReadableDateDDMMYYYY(item.JoinDate)}
                        </span>
                      </div>
                      <div>
                        <span
                          className="flex items-center justify-center font-semibold hover:underline"
                          style={{ color: "#7f7f7f", fontSize: "10px" }}
                        >
                          View Details
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
        {loader && (
          <div className="table-nodata-img">
            <div className="center">
              <p className="text-center pt-5">
                Please Wait Loading Data...
                <FallingLines />
              </p>
            </div>
          </div>
        )}
        {records && (
          <div className="pagination-div">
            <div className="text-end">
              <nav aria-label="Page navigation example">
                <ul className="pagination mb-12">
                  {currentPage !== 1 && (
                    <li className="page-item">
                      <button className="page-link" onClick={prePage}>
                        Previous
                      </button>
                    </li>
                  )}
                  {numbers.map((n, i) => (
                    <li
                      className={`page-item ${currentPage === n ? "active" : ""}`}
                      key={i}
                    >
                      <button
                        className="page-link"
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </button>
                    </li>
                  ))}
                  {currentPage !== npage && (
                    <li className="page-item">
                      <button className="page-link" onClick={nextPage}>
                        Next
                      </button>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Employee;
